
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"prefix__a","d":"M1.5 16.5h15v-15h-15v15zm0 1.5C.673 18 0 17.378 0 16.612V1.389C0 .622.673 0 1.5 0h15c.827 0 1.5.622 1.5 1.39v15.222c0 .766-.673 1.388-1.5 1.388h-15zm0-5.25h15a.75.75 0 010 1.5h-15a.75.75 0 010-1.5zM6 4.437a1.124 1.124 0 011.733-.946l4.182 2.688a1.124 1.124 0 010 1.892L7.733 10.76A1.126 1.126 0 016 9.814V4.437zm1.5 4.69l3.113-2.002L7.5 5.124v4.002z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"prefix__b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#prefix__a"}})]),_c('use',{attrs:{"fill":"#8C99AD","fill-rule":"nonzero","xlink:href":"#prefix__a"}}),_c('g',{attrs:{"fill":"#2B2B2B","mask":"url(#prefix__b)"}},[_c('path',{attrs:{"d":"M-3-3h24v24H-3z"}})])])])
          )
        }
      }
    